export default "/images/vendor/flag-icons/flags/1x1/gi.svg?1b8feafa6ccc32e8d26515eb2012d1c1";